import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import {
  baseUrl,
  GET_JOB_COUNT,
  GET_LAWYERS_LIST,
  HEADERS_EXPORT,
} from "../../../API/apiUrls";
import TokenCheck from "../../../../hook/TokenCheck";

const LoadLawyers = () => {
  const [lawyersList, setLawyersList] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [loadLawyerJobs, setLoadLawyerJobs] = useState([]);
  const [lawyerJobs, setLawyerJobs] = useState([]);
  const [signOut] = TokenCheck();

  useEffect(() => {
    if (loadingData) {
      loadData();
    }
  }, [loadingData]);

  const loadData = async () => {
    console.log("loadData LoadLawyers");

    try {
      // 1. รอรับค่าด้วย await (ไม่ต้องใช้ .then แล้ว)
      const response = await axios.get(baseUrl + GET_LAWYERS_LIST, {
        headers: HEADERS_EXPORT, // ส่ง headers ตามที่คุณตั้งใจไว้
      });

      // 2. ถ้าทำงานสำเร็จ (Status 2xx) โค้ดจะรันบรรทัดนี้
      setLawyersList(response.data);
      console.log("res", response.data);
    } catch (error) {
      // 3. ถ้าพัง (Status 4xx, 5xx หรือเน็ตหลุด) จะเด้งมาที่นี่ที่เดียว
      if (error.response?.data === "Session expired") {
        signOut();
      } else {
        // เคลียร์ค่า state กลับเป็นค่าว่างเพื่อไม่ให้มีข้อมูลเก่าค้าง
        setLawyersList([]);
        console.error("Error fetching lawyers data:", error);

        // แจ้งเตือนข้อผิดพลาด
        const errorMessage =
          error.response?.data?.message ||
          "เกิดข้อผิดพลาดในการดึงข้อมูลทนายความ";
        message.error(errorMessage);
      }

      // try {
      //   await axios

      //     .get(baseUrl + GET_JOB_COUNT, {
      //       headers: HEADERS_EXPORT,
      //     })
      //     .then(async (res) => {
      //       if (res.status === 200) {
      //         setLoadLawyerJobs(res.data);
      //         console.log("data in", res.data);
      //       } else {
      //         message.error("ไม่มีข้อมูล");
      //         console.log("ไม่มีข้อมูล");
      //       }
      //     })
      //     .catch((err) => console.log("ไม่มีข้อมูล", err));
      // } catch (error) {
      //   console.error("Error fetching data:", error);
      //   message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
      // }
    }
  };

  return [lawyersList, setLoadingData, loadLawyerJobs];
};

export default LoadLawyers;
